function rotatePoint(point, center, angleDegrees) {
  const radians = (angleDegrees * Math.PI) / 180;
  const cosAngle = Math.cos(radians);
  const sinAngle = Math.sin(radians);
  const translatedPoint = [point[0] - center[0], point[1] - center[1]];
  const rotatedX =
    translatedPoint[0] * cosAngle - translatedPoint[1] * sinAngle;
  const rotatedY =
    translatedPoint[0] * sinAngle + translatedPoint[1] * cosAngle;
  return [rotatedX + center[0], rotatedY + center[1]];
}

function translatePoint(point, translationX, translationY) {
  return [point[0] + translationX, point[1] + translationY];
}

export function buildMaskCoordinateContext(
  dimensions,
  rotationAngleDegrees = 0,
) {
  const processedWidth = dimensions.processedWidth;
  const processedHeight = dimensions.processedHeight;
  const originalWidth = dimensions.originalWidth;
  const originalHeight = dimensions.originalHeight;
  const rotationAngle = rotationAngleDegrees;

  const rotatedImageOriginalToProcessed = [
    [0, 0],
    [originalWidth, 0],
    [originalWidth, originalHeight],
    [0, originalHeight],
  ].map((point) => rotatePoint(point, [0, 0], -rotationAngle));

  const rotatedImageProcessedToOriginal = [
    [0, 0],
    [processedWidth, 0],
    [processedWidth, processedHeight],
    [0, processedHeight],
  ].map((point) => rotatePoint(point, [0, 0], rotationAngle));

  return {
    rotationAngle,
    translationXOriginalToProcessed: Math.min(
      ...rotatedImageOriginalToProcessed.map((point) => Math.floor(point[0])),
    ),
    translationYOriginalToProcessed: Math.min(
      ...rotatedImageOriginalToProcessed.map((point) => Math.floor(point[1])),
    ),
    translationXProcessedToOriginal: Math.min(
      ...rotatedImageProcessedToOriginal.map((point) => Math.floor(point[0])),
    ),
    translationYProcessedToOriginal: Math.min(
      ...rotatedImageProcessedToOriginal.map((point) => Math.floor(point[1])),
    ),
  };
}

export function originalToStage(point, context, scale) {
  return translatePoint(
    rotatePoint(
      [point[0] * scale, point[1] * scale],
      [0, 0],
      -context.rotationAngle,
    ),
    -context.translationXOriginalToProcessed * scale,
    -context.translationYOriginalToProcessed * scale,
  );
}

export function stageToOriginal(point, context, scale) {
  return translatePoint(
    rotatePoint(
      [Math.round(point[0] / scale), Math.round(point[1] / scale)],
      [0, 0],
      context.rotationAngle,
    ),
    -context.translationXProcessedToOriginal,
    -context.translationYProcessedToOriginal,
  ).map((number) => Math.ceil(number));
}

export function polygonToStageLinePoints(polygon, context, scale) {
  return polygon.map((point) => originalToStage(point, context, scale)).flat();
}
